/** Каталог прав дашборда (зеркалит backend dashboard.api.permissions). */

export const PERM = {
  EXECUTIVE_VIEW: "executive.view",
  SURVEYS_VIEW: "surveys.view",
  MANAGER_REPORTS_VIEW: "manager_reports.view",
  TASKS_ACCESS: "tasks.access",
  CLIENTS_ACCESS: "clients.access",
  KONTUR_ACCESS: "kontur.access",
  CLIENTS_FEE: "clients.fee",
  FINANCE_ACCESS: "finance.access",
  VACATIONS_ACCESS: "vacations.access",
  SETTINGS_ACCESS: "settings.access",
  EMPLOYEES_MANAGE: "employees.manage",
  USERS_MANAGE: "users.manage",
  VPN_ADMIN: "vpn.admin",
  REGULATIONS_MANAGE: "regulations.manage",
};

export const PERMISSION_CATALOG = [
  { code: PERM.EXECUTIVE_VIEW, label: "Командный центр" },
  { code: PERM.SURVEYS_VIEW, label: "Опросы" },
  { code: PERM.MANAGER_REPORTS_VIEW, label: "Ежедневные отчёты" },
  { code: PERM.TASKS_ACCESS, label: "Задачи" },
  { code: PERM.CLIENTS_ACCESS, label: "Клиенты" },
  { code: PERM.KONTUR_ACCESS, label: "Оплаты Контура" },
  { code: PERM.CLIENTS_FEE, label: "Оплата клиентов" },
  { code: PERM.FINANCE_ACCESS, label: "Финансы" },
  { code: PERM.VACATIONS_ACCESS, label: "График отпусков" },
  { code: PERM.SETTINGS_ACCESS, label: "Настройки" },
  { code: PERM.EMPLOYEES_MANAGE, label: "Сотрудники" },
  { code: PERM.USERS_MANAGE, label: "Пользователи" },
  { code: PERM.VPN_ADMIN, label: "VPN-админка" },
  { code: PERM.REGULATIONS_MANAGE, label: "Правка регламентов" },
];

export const ROLE_PRESETS = {
  manager: [
    PERM.SURVEYS_VIEW,
    PERM.MANAGER_REPORTS_VIEW,
    PERM.TASKS_ACCESS,
    PERM.CLIENTS_ACCESS,
    PERM.KONTUR_ACCESS,
    PERM.CLIENTS_FEE,
    PERM.VACATIONS_ACCESS,
    PERM.SETTINGS_ACCESS,
    PERM.EMPLOYEES_MANAGE,
    PERM.USERS_MANAGE,
    PERM.REGULATIONS_MANAGE,
  ],
  admin: [
    PERM.TASKS_ACCESS,
    PERM.CLIENTS_ACCESS,
    PERM.KONTUR_ACCESS,
    PERM.CLIENTS_FEE,
    PERM.VACATIONS_ACCESS,
    PERM.SETTINGS_ACCESS,
    PERM.VPN_ADMIN,
  ],
};

/** Приоритет путей для landing после логина */
export const PATH_PERMISSION_PRIORITY = [
  { path: "/", permission: PERM.SURVEYS_VIEW },
  { path: "/tasks", permission: PERM.TASKS_ACCESS },
  { path: "/vacations", permission: PERM.VACATIONS_ACCESS },
  { path: "/client-directory", permission: PERM.CLIENTS_ACCESS },
  { path: "/client-payments", permission: PERM.CLIENTS_FEE },
  { path: "/kontur-payments", permission: PERM.KONTUR_ACCESS },
  { path: "/settings", permission: PERM.SETTINGS_ACCESS },
  { path: "/manager", permission: PERM.MANAGER_REPORTS_VIEW },
  { path: "/executive", permission: PERM.EXECUTIVE_VIEW },
  { path: "/users", permission: PERM.USERS_MANAGE },
  { path: "/employees", permission: PERM.EMPLOYEES_MANAGE },
  { path: "/vpn-admin", permission: PERM.VPN_ADMIN },
  { path: "/finance", permission: PERM.FINANCE_ACCESS },
];

export function hasPermission(user, code) {
  const perms = user?.permissions;
  if (!Array.isArray(perms)) return false;
  return perms.includes(code);
}

export function getDefaultPathForUser(user) {
  if (!user) return "/login";
  for (const item of PATH_PERMISSION_PRIORITY) {
    if (hasPermission(user, item.permission)) {
      return item.path;
    }
  }
  return "/settings";
}
